<!-- =========================================================================================
  File Name: fournisseuractualites.vue
  Description: actualites Page
  ----------------------------------------------------------------------------------------

========================================================================================== -->

<template>
  <div id="actualites-clients">
    <div class="vx-col md:w-5/5 sm:w-full lg:w-5/5 mb-base h-full">
      <vx-card slot="no-body" class="text-center greet-user classDEFAULT" :style="myStyle">
        <feather-icon icon="AwardIcon" class="md:p-2 lg:p-6 mb-3 md:mb-3 lg:mb-6 xl:mb-12 inline-flex rounded-full text-white shadow" svgClasses="h-7 w-7"></feather-icon>
        <h1 class="mb-2 text-white">{{ getSalutation() }} {{ customerUserName }}</h1>
        <h2 class="mb-2 text-white">Bienvenue sur COGEPHA LIVE.</h2>
      </vx-card>
    </div>
    <div class="vx-row mb-1">
      <!-- CARD 1: CONGRATS -->
      <!-- <div class="vx-col md:w-2/5 sm:w-full lg:w-2/5 mb-base h-full">
        <vx-card slot="no-body" class="text-center greet-user classDEFAULT" :class="colorByClass">
          <feather-icon icon="AwardIcon" class="md:p-2 lg:p-6 mb-3 md:mb-3 lg:mb-6 xl:mb-12 inline-flex rounded-full text-white shadow" :class="colorByClass" svgClasses="h-7 w-7"></feather-icon>
          <h1 class="mb-2 text-white">BONJOUR {{ customerUserName }}</h1>
          <h2 class="mb-2 text-white">Bienvenue sur COGEPHA LIVE.</h2>
        </vx-card>
      </div> -->

      <div class="vx-col md:w-6/6 sm:w-full lg:w-6/6 mb-base">
        <div class="vx-row">
          <!-- CARD 2: SUBSCRIBERS GAINED -->
          <div class="vx-col p-2 sm:w-full md:w-1/6 lg:w-1/6 xl:w-1/6">
            <statistics-card-line :key="dataupdateKey" icon="MinusIcon" :statistic="Shipped_Not_Invoiced_LCY + ' DT'" statisticTitle="Livraisons non facturées" color="warning" class=""></statistics-card-line>
          </div>

          <!-- CARD 3: ORDER RECIEVED -->
          <div class="vx-col p-2 sm:w-full md:w-1/6 lg:w-1/6 xl:w-1/6">
            <statistics-card-line :key="dataupdateKey" icon="PlusIcon" :statistic="Unbilled_returns + ' DT'" statisticTitle="Retours non facturées"></statistics-card-line>
          </div>
          <div class="vx-col p-2 sm:w-full md:w-1/6 lg:w-1/6 xl:w-1/6">
            <statistics-card-line :key="dataupdateKey" icon="PlusIcon" :statistic="nbrePointFidelite + ' Points'" statisticTitle="Points Fidélité" color="danger" class=""></statistics-card-line>
          </div>
          <!--*********************Pile Arrivage*************************-->
          <div class="vx-col p-2 sm:w-full md:w-1/6 lg:w-1/6 xl:w-1/6" @click="arrivagePageLoad()">
            <a href='#'><statistics-card-line :key="dataupdateKey" icon="ArrowDownCircleIcon" :statistic="nbrArrivage()" statisticTitle="Arrivages" color="warning" class=""></statistics-card-line></a>
          </div>
          <!--*********************Pile Création*************************-->
          <div class="vx-col p-2 sm:w-full md:w-1/6 lg:w-1/6 xl:w-1/6" @click="creationPageLoad()">
            <a href='#'><statistics-card-line :key="dataupdateKey" icon="FeatherIcon" :statistic="nbrCreation()" statisticTitle="Créations" class=""></statistics-card-line></a>
          </div>
          <!--*********************Pile Promotion*************************-->
          <div class="vx-col p-2 sm:w-full md:w-1/6 lg:w-1/6 xl:w-1/6" @click="promotionPageLoad()">
            <a href='#'><statistics-card-line :key="dataupdateKey" icon="LayersIcon" :statistic="nbrPromotion()" statisticTitle="Promotions" color="danger" class=""></statistics-card-line></a>
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/5 sm:w-full lg:w-1/5 mb-base"></div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col md:w-1/2 sm:w-full lg:w-1/2 mb-base">
        <vx-card title="Répartition d'achat par mois en dinars" @refresh="onChange()" class="">
          <div slot="no-body" class="mt-2">
            <repartition-chiffre-afaire-courant :key="periode + selectedyear" />
          </div>
        </vx-card>
      </div>
      <div class="vx-col md:w-1/2 sm:w-full lg:w-1/2 mb-base h-full">
        <vx-card title="Variation de classification par mois" @refresh="onChange()" class="">
          <div slot="no-body" class="mt-2">
            <class-repartition :key="periode + selectedyear" />
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col md:w-1/2 sm:w-full lg:w-1/2">
        <vx-card title="Evolution de Nombre de Commandes par mois " class="">
          <evolution-nbre-commande-par-mois />
        </vx-card>
      </div>
      <div class="vx-col md:w-1/2 sm:w-full lg:w-1/2">
        <vx-card title="Evolution de Nombre de Retours par mois " class="">
          <evolution-nbre-retour-par-mois />
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import RepartitionChiffreAfaireCourant from "./RepartitionChiffreAfaireCourant.vue";
import EvolutionNbreCommandeParMois from "./EvolutionNbreCommandeParMois.vue";
import ClassRepartition from "./ClassRepartition.vue";
import EvolutionNbreRetourParMois from "./EvolutionNbreRetourParMois.vue";
import arrivageService from "@/http/requests/arrivage/index.js";
import nouvelArticleService from "@/http/requests/NouvelArticle/index.js";
export default {
  name: "fourn-act",
  data() {
    return {
      myStyle: {
        backgroundColor: "#28c76f",
      },
      totalachatMois: 0,
      dataupdateKey: 0,
      dataArrivage: [],
      dataCreation: [],
      thisMonth: new Date().getMonth() + 1,
      thisYear: new Date().getFullYear(),
      periode: this.$store.state.article.analytcsdata.periode,
      selectedyear: this.$store.state.article.analytcsdata.selectedyear,
      checkpointReward: {
        userName: "",
        progress: "",
      },

      cogephaSelesSum: {
        Unbilled_returns: 0,

        Shipped_Not_Invoiced_LCY: 0,
      },
    };
  },
  computed: {
    Shipped_Not_Invoiced_LCY: function () {
      return this.$store.state.article.analytcsdata.userInfo.Shipped_Not_Invoiced_LCY;
    },
    Unbilled_returns: function () {
      return this.$store.state.article.analytcsdata.userInfo.Unbilled_returns;
    },
    nbrePointFidelite: function () {
      return this.$store.state.AppActiveUser.nbPoint;
    },
    colorByClass: function () {
      console.log("trabelsi");
      console.log(this.currentClass);
      switch (this.currentClass) {
        case "SILVER":
          return "SILVERCOLOR";
        case "BRONZE":
          return "BRONZECOLOR";
        case "GOLD":
          return "GOLDCOLOR";
        case "DORMANT":
          return "DORMANTCOLOR";
        case "EXPRESS":
          return "EXPRESSCOLOR";
        case "DIAMANT":
          return "DIAMANTCOLOR";
        case "PLATINUM":
          return "PLATINUMCOLOR";
        default:
          return "DEFAULTCOLOR";
      }
    },
    currentClass: function () {
      return this.$store.state.article.analytcsdata.listData.length > 0 ? this.$store.state.article.analytcsdata.listData[this.$store.state.article.analytcsdata.listData.length - 1].Class : "";
    },
    customerUserName: function () {
      return this.$store.state.AppActiveUser.prenom != null ? this.$store.state.AppActiveUser.nom + " " + this.$store.state.AppActiveUser.prenom : this.$store.state.AppActiveUser.nom;
    },
  },
  methods: {
    arrivagePageLoad(){
      this.$router.push("/ArrivageClient");
    },
    creationPageLoad(){
      this.$router.push("/NouvelArticle");
    },
    promotionPageLoad(){
      console.log("promo")
      //this.$router.push("");
    },
    //getSalutation(): change le mot bonjour suivant l'heure (supèrieure à 15h sera bonsoir)
    getSalutation() {
      var heures = new Date().getHours();
      console.log(heures);
      if (heures > 15) {
        return "BONSOIR";
      } else {
        return "BONJOUR";
      }
    },
    //************************************* FIn getSalutation *************************************************
    //************************************* récupération de la liste des articles en arrivage***************
    getArrrivage() {
      try {
        var code = localStorage.getItem("username", JSON.stringify());
        arrivageService.getListArrivageParMagasin(code).then((response) => {
          this.dataArrivage = response.data;
        });
      } catch {
        this.$vs.loading.close();
        this.$vs.notify({
          time: 10000,
          title: "Erreur s'est produite l'ors de la récupération de données",
          text: "Erreur",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circles",
        });
      }
    },
    //*********************************** Fin Arrivage ***************************************************
    // récupérer le nombre d'arrivage pour l'afficher dans la pile arrivage
    nbrArrivage() {
      return this.dataArrivage.length;
    },

    //************************************* récupération de la liste des articles en création***************
    getCreation() {
      try {
        var code = localStorage.getItem("username", JSON.stringify());
        nouvelArticleService.getListCreationParMagasin(code).then((response) => {
          this.dataCreation = response.data;
        });
      } catch {
        this.$vs.notify({
          time: 10000,
          title: "Erreur s'est produite l'ors de la récupération de données",
          text: "Erreur",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circles",
        });
      }
    },
    //*********************************** Fin Création ***************************************************
    // récupérer le nombre des articles en création pour l'afficher dans la pile création
    nbrCreation() {
      return this.dataCreation.length;
    },
    // récupérer le nombre des articles en promotion pour l'afficher dans la pile promotion
    nbrPromotion() {
      return "Promotion";
    },
    onChangeyear(event) {
      this.selectedyear = event.target.value;

      this.$store.dispatch("article/UPDATE_PERIODE_YEAR", event.target.value);
    },
    onChangetrimestre(event) {
      this.periode = event.target.value;
      this.$store.dispatch("article/UPDATE_PERIODE", event.target.value);
    },
  },
  // Chargement de la liste des arrivages, des créations lors de l'ouverture de la page accueil client
  created() {
    //Chargement liste arrivage
    this.getArrrivage();
    // Chargement liste création
    this.getCreation();
  },

  components: {
    VueApexCharts,
    StatisticsCardLine,
    RepartitionChiffreAfaireCourant,
    EvolutionNbreCommandeParMois,
    ClassRepartition,
    EvolutionNbreRetourParMois,
  },
};
</script>

<style lang="scss">
#actualites-clients {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .rowHight {
    height: 35%;
  }

  .DIAMANTCOLOR {
    background-color: #cee4e6;
  }

  .PLATINUMCOLOR {
    background-color: #c3cad0;
  }

  .GOLDCOLOR {
    background-color: #ffd700;
  }

  .SILVERCOLOR {
    background-color: #c0c0c0;
  }

  .BRONZECOLOR {
    background-color: #614e1a;
  }

  .EXPRESSCOLOR {
    background-color: #c5473b;
  }

  .DORMANTCOLOR {
    background-color: #b36700;
  }

  .DEFAULTCOLOR {
    background-color: #b61616;
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
